import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatSelect } from '@angular/material/select';
import { filter } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { EventRejectComponent } from '../event-reject/event-reject.component';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-event-add',
  templateUrl: './event-add.component.html',
  styleUrls: ['./event-add.component.css'],
})
export class EventAddComponent implements OnInit {
  uploadedFile: File | null = null;
  selectedFileName: string | null = null;
  bsLastValue;
  bsFromValue;
  bsToValue;
  private eventupdate = environment.url + environment.eventApproved;
  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
  applyLastMin;
  fromDateMin;
  fromDateMax;
  lastDateMin;
  eventForm: FormGroup;
  datas;
  private saveApi = environment.url + environment.eventSave;
  private getApi = environment.url + environment.eventGet;
  displayedColumns: string[] = [
    'index',
    'eventName',
    'eventFromDate',
    'eventToDate',
    'eventFromTime',
    'eventToTime',
    'incubatorName',
    'remarks',
    'status',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  /**
   * EventAddComponent constructor.
   * @param data dialog data
   * @param _locale MAT_DATE_LOCALE
   * @param route ActivatedRoute
   * @param fb FormBuilder
   * @param makeapi ApiService
   * @param getdata ValueService
   * @param notify NotifyService
   * @param sanitizer DomSanitizer
   * @param dialogRef MatDialogRef<EventAddComponent>
   * @param dialog MatDialog
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<EventAddComponent>,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the component with the given data.
     */
    this.dataSource = new MatTableDataSource();
    this.datas = data;
    if (data.title == 'Update') {
      /**
       * Set the save button label to 'Update' if the data is from the update button.
       */
      this.savelbl = 'Update';
      /**
       * Get the event details from the database.
       */
      this.getEventDetails(data._id);
    } else {
      /**
       * Set the apply last date to today if the data is from the add button.
       */
      this.applyLastMin = new Date();
      /**
       * Set the from date to today if the data is from the add button.
       */
      this.fromDateMin = new Date();
    }
    /**
     * Create the event form with the given fields.
     */
    this.eventForm = this.fb.group({
      id: [0],
      incubatorId: [],
      incubatorName: [''],
      eventName: ['', [Validators.required]],
      eventLocation: ['', [Validators.required]],
      eventFromDate: ['', [Validators.required]],
      eventToDate: [''],
      eventFromTime: ['', [Validators.required]],
      eventToTime: [''],
      eventRegQRFileName: [''],
      eventRegQR: [''],
      eventRegLink: [''],
      eventWebsiteLink: [''],
      eventImageName: [''],
      eventImage: [''],
      eventDescription: [''],
      eventApplyLastDate: [''],
    });
  }
  getFromDate(event) {
    this.lastDateMin = event;
  }
  getToDate(event) {
    this.fromDateMax = event;
  }
  get add() {
    return this.eventForm.controls;
  }
  roleValue;
  savelbl = 'Save';
  statusValue: number = 0;
  userId;
  /**
   * Initializes the component. Sets visibility, retrieves query parameters,
   * and patches form values with session data.
   */
  ngOnInit(): void {
    // Make the component visible
    this.getdata.isVisibleSource.next(true);

    // Listen for query parameter changes and view the event if _id exists
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        this.viewEvent(atob(params._id)); // Decode the _id and view event
      });

    // Retrieve user role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Retrieve userId from session storage and update the form
    let id: number = +sessionStorage.getItem('userId');
    let getform = this.eventForm.value;
    getform.incubatorId = id;
    this.eventForm.patchValue(getform); // Patch the form with the updated values
    if (this.statusValue === 2) {
      this.eventForm.disable(); // disable all controls
    }
  }
  namePush = [];
  /**
   * Retrieves event details from the server and patches the form with the data.
   * The retrieved data includes the event's image, QR code, and dates.
   * The dates are converted to the correct format for the datepickers.
   * @param id The id of the event to retrieve.
   */
  getEventDetails(id) {
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'get')
      .subscribe((data) => {
        this.eventForm.patchValue(data);
        if (data.eventImageName != '' && data.eventImageName != undefined) {
          // Set the image and its name
          this.ImageValue = data.eventImage;
          this.image_url = data.eventImageName;
          this.img_name = data.eventImageName;
          // Set the statusValue values (status and id)
          this.statusValue = data.status;
        }
        if (
          data.eventRegQRFileName != '' &&
          data.eventRegQRFileName != undefined
        ) {
          // Set the QR code and its name
          this.FileValue = data.eventRegQRFile;
          this.FileName = data.eventRegQRFileName;
          this.docName = '✔ Uploaded';
        }
        // Set the apply last date
        if (data.eventApplyLastDate != undefined) {
          let splitValue = data.eventApplyLastDate.split('/');
          let date: number = +splitValue[0];
          let month: number = +splitValue[1] - 1;
          let year: number = +splitValue[2];
          this.bsLastValue = new Date(Date.UTC(year, month, date));
        }
        // Set the from date
        if (data.eventFromDate != undefined) {
          let splitValue = data.eventFromDate.split('/');
          let date: number = +splitValue[0];
          let month: number = +splitValue[1] - 1;
          let year: number = +splitValue[2];
          this.bsFromValue = new Date(Date.UTC(year, month, date));
        }
        // Set the to date
        if (data.eventToDate != undefined) {
          let splitValue = data.eventToDate.split('/');
          let date: number = +splitValue[0];
          let month: number = +splitValue[1] - 1;
          let year: number = +splitValue[2];
          this.bsToValue = new Date(Date.UTC(year, month, date));
        }
        if (data.status === 2) {
          this.eventForm.disable(); // disable all controls
        }
      });
  }
  ImageValue: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/upload.png';
  img_name = '';
  image_url: any = 'assets/images/upload.png';
  img: any;
  logoCheck = false;
  /**
   * Select an image and set the selected image value, image name, and image URL
   * @param event - Event triggered when an image is selected
   */
  onSelectImage(event) {
    this.selecetdImage = event.target.files[0];
    if (event.target.files && this.selecetdImage) {
      // Read the selected image and set the image value, image name, and image URL
      let reader = new FileReader();
      let data = this.selecetdImage;
      this.imagetype = data.type;
      let imagedatatype = this.imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        // Only allow jpeg, jpg, and png formats
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png'
      ) {
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          this.url1 = reader.result;
          let spl = this.url1.split(',');
          this.ImageValue = spl[1];
          this.img_name = this.fileValue.name;
          this.logoCheck = false;
          this.image_url = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
          this.uploadedFile = event.target.files[0] || null;
          // Set selected file name
          if (this.uploadedFile) {
            this.selectedFileName = this.uploadedFile.name;
          }
        };
      } else {
        this.img = 'show';
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }

  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  docName;
  /**
   * File upload function
   * @param event - The event triggered when a file is selected
   */
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      // Read the selected file and set the file value and file name
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        // Only allow jpeg, jpg, and png formats
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          // Set the file value and file name
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.docName = this.selecetdFile.name;
        };
      } else {
        // Show error message if the file format is not allowed
        this.notify.notifyError('Only *jpeg,*jpg,*png formets are allowed');
      }
    }
  }
  /**
   * Deletes the uploaded event registration QR code image
   */
  deleteImage() {
    // Reset the file value and file name
    this.FileValue = '';
    this.FileName = '';
    this.docName = '';

    // Get the current form values
    let getform = this.eventForm.value;

    // Reset the event registration QR code and its file name
    getform.eventRegQR = '';
    getform.eventRegQRFileName = '';

    // Update the form with the new values
    this.eventForm.patchValue(getform);
  }
  /**
   * Saves the event details by validating the form and submitting it to the API.
   * Displays notifications based on the success or failure of the operation.
   */
  saveEvent() {
    // Get the current form values
    let getform = this.eventForm.value;

    // Check if the image value is empty or the form is invalid
    if (this.ImageValue == '' || this.eventForm.invalid) {
      if (this.ImageValue == '') {
        this.logoCheck = true; // Set logo check to true if image is empty
      }
      this.eventForm.markAllAsTouched(); // Mark all form fields as touched
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Format 'eventFromDate' if it is an object
      if (
        getform.eventFromDate != undefined &&
        typeof getform.eventFromDate === 'object'
      ) {
        let fromDate = moment(getform.eventFromDate).format('DD/MM/YYYY');
        getform.eventFromDate = fromDate;
      }

      // Format 'eventToDate' if it is an object
      if (
        getform.eventToDate != undefined &&
        typeof getform.eventToDate === 'object'
      ) {
        let toDate = moment(getform.eventToDate).format('DD/MM/YYYY');
        getform.eventToDate = toDate;
      }

      // Format 'eventApplyLastDate' if it is an object
      if (
        getform.eventApplyLastDate != undefined &&
        typeof getform.eventApplyLastDate === 'object'
      ) {
        let lastDate = moment(getform.eventApplyLastDate).format('DD/MM/YYYY');
        getform.eventApplyLastDate = lastDate;
      }

      // Set event image details if image value is not empty
      if (this.ImageValue != '') {
        getform.eventImage = this.ImageValue;
        getform.eventImageName = this.img_name;
      }

      // Set event registration QR code details if file value is not empty
      if (this.FileValue != '' && this.FileValue != undefined) {
        getform.eventRegQR = this.FileValue;
        getform.eventRegQRFileName = this.FileName;
      }

      // Show loader and submit the form data via API
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe(
        (data) => {
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus == 'Success') {
            this.notify.notifysuccess(data.responseMessage);
            this.cancelEvent(); // Reset the form on success
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        },
        (error) => {
          this.getdata.amizhthLoader('hide');
        }
      );
    }
  }
  /**
   * This function resets the form and closes the dialog box.
   * It is called when user clicks on the cancel button.
   */
  cancelEvent() {
    // Reset the form
    this.eventForm.reset();
    // Close the dialog box
    this.dialogRef.close();
  }

  protected _onDestroy = new Subject();
  public Editor = ClassicEditor;
  public onReady(editor: ClassicEditor) {}
  public onChange({ editor }: ChangeEvent) {}
  eventView: any = [];
  /**
   * This function fetches event details by ID and stores it in the `eventView` property.
   * It is called when user clicks on the view button.
   * @param id Event ID
   */
  viewEvent(id) {
    // Show loader
    this.getdata.amizhthLoader('show');
    // Fetch event details via API
    return this.makeapi
      .method(this.getApi + 'id=' + id, '', 'getunauth')
      .subscribe((data) => {
        // Hide loader
        this.getdata.amizhthLoader('hide');
        // Store event details in the `eventView` property
        this.eventView = data;
      });
  }
  backBtn() {
    this.dialogRef.close();
  }
  sam;
  /**
   * This function approves an event by sending a request to the API.
   * It is called when user clicks on the approve button.
   * @param eventForm Form containing event details
   */
  ApprovedBtn(eventForm) {
    // Extract event ID from the form
    this.sam = eventForm.value.id;

    // Prepare request payload
    let req = {
      id: this.sam,
      status: 1, // Status 1 indicates approval
    };

    // Send approval request to the API
    return this.makeapi
      .method(this.eventupdate, req, 'post')
      .subscribe((data) => {
        // Notify success
        this.notify.notifysuccess(data.responseMessage);

        // Close the dialog box
        this.dialogRef.close();

        // Reload the page
        window.location.reload();
      });
  }
  /**
   * This function opens the event reject dialog box.
   * It is called when user clicks on the reject button.
   * @param eventForm Form containing event details
   */
  RejectBtn(eventForm) {
    // Extract event ID from the form
    let sam = eventForm.value.id;

    // Open the event reject dialog box
    const dialogRef = this.dialog.open(EventRejectComponent, {
      width: '390px',
      data: { _id: sam },
    });

    // Handle dialog box close event
    dialogRef.afterClosed().subscribe((result) => {
      // Notify that the event status has changed
      this.getdata.isVisibleSource.next(true);

      // Reload the page
      this.backBtn();
    });

    // Close the current dialog box
    // this.dialogRef.close();
  }
}
